module.exports = __webpack_public_path__ + "static/media/fregadero.cdc5d84f.svg";